import { useSuspenseQuery } from '@apollo/client/react';
import { ErrorAlert } from '@optools/components/alerts/error';
import { ScrollPage } from '@optools/components/layout/layout';
import { ESNI_RULES } from '@optools/services/operator-gateway/esni/queries';
import { ESNIRulesTable } from '@optools/tools/esni/components/rules/esni-rules-table';
import { ESNIRulesTableSkeleton } from '@optools/tools/esni/components/rules/esni-rules-table-skeleton';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/esni/rules/')({
  component: RouteComponent,
  pendingComponent: ESNIRulesTableSkeleton,
});

export function RouteComponent() {
  const {
    data: { esniRules },
    error,
    refetch,
  } = useSuspenseQuery(ESNI_RULES, {
    context: { skipErrorNotification: true },
  });

  if (error) {
    return <ErrorAlert error={error} title="ESNI Rules Error" onRetry={refetch} />;
  }

  return (
    <ScrollPage>
      <ESNIRulesTable data={esniRules} />
    </ScrollPage>
  );
}
